import { render, staticRenderFns } from "./privacyphone.vue?vue&type=template&id=6096d044"
import script from "./privacyphone.vue?vue&type=script&lang=js"
export * from "./privacyphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports